export default "__VITE_ASSET__fhsou9Ff__"